import { Flex } from '@lego/klik-ui';
import { DeviceDeployment } from '@/components/device/DeviceDeployment';
import type { DeviceResponse } from '@/hooks/device';

type Props = {
  device: DeviceResponse;
};

export const DeviceDeployments = ({ device }: Props) => {
  return (
    <Flex direction="column" gap={8}>
      <DeviceDeployment device={device} />
    </Flex>
  );
};
